if (!customElements.get('affirm-widget')) {
    class AffirmWidget extends HTMLElement {
        connectedCallback() {
            this.message = this.querySelector('.affirm-as-low-as');
            this.source = this.closest('[data-product-card-selected_variant_id]');

            if (!this.message) return;

            this.template = this.message.cloneNode(false);

            try {
                this.prices = JSON.parse(this.querySelector('[data-variant-prices]')?.textContent || '{}');
            } catch {
                this.prices = {};
            }

            if (this.source) {
                this.observer = new MutationObserver(this.handleMutations.bind(this));

                this.observer.observe(this.source, {
                    attributes: true,
                    attributeFilter: ['data-product-card-selected_variant_id']
                });

                this.setAmount(this.source.getAttribute('data-product-card-selected_variant_id'));
            }

            this.refresh();
        }

        disconnectedCallback() {
            this.observer?.disconnect();
        }

        handleMutations() {
            cancelAnimationFrame(this.raf);

            this.raf = requestAnimationFrame(() => {
                const id = this.source.getAttribute('data-product-card-selected_variant_id');

                if (!id || id === this.currentId) return;

                this.updateWidget(id);
            });
        }

        updateWidget(variantId) {
            if (this.prices[variantId] === undefined) return;

            this.replaceMessage();
            this.setAmount(variantId);
            this.refresh();
        }

        replaceMessage() {
            const message = this.template.cloneNode(false);

            message.innerHTML = this.message.innerHTML;
            this.message.replaceWith(message);
            this.message = message;
        }

        setAmount(variantId) {
            const amount = this.prices[variantId];

            if (amount === undefined) return false;

            this.currentId = variantId;
            this.message.setAttribute('data-amount', amount);

            return true;
        }

        refresh() {
            window.affirm?.ui?.ready?.(() => window.affirm.ui.refresh());
        }
    }

    customElements.define('affirm-widget', AffirmWidget);
}